import { compose, withProps, onlyUpdateForKeys, setDisplayName } from 'recompose';
import { withRouter } from 'react-router-dom';
import * as React from 'react';
import Dictionary from '@inqool/uas-web-core/es/components/app/Dictionary';
import { breadcrumbs } from '@inqool/uas-web-core/es/utils';
import { withClassname } from '@components/hoc/withClassname';
import { RequestsPayForm } from '@modules/hr-requests/pays/RequestsPayForm';
import { withAdditionalProps } from '@components/hoc/withAdditionalProps';
import { withColumns } from '@components/hoc/withColumns';
import { Agenda } from '@modules/columnSettings/_columnSettingsEnums';
import { ColumnManager } from '@modules/columnSettings/ColumnManager';

export const requestsPayUrl = '/metropolis/api/hr/workplan/request-pay';
export const requestsPayLabel = 'Proplacení nadčasú';
export const requestsPayPath = '/hr/requests/pay';
export const requestsPayGridName = 'RequestsPayGrid';
export const RequestsPayGrid = compose(
  withRouter,
  setDisplayName(requestsPayGridName),
  onlyUpdateForKeys(['url', 'location']),
  breadcrumbs([{ label: requestsPayLabel }]),
  withColumns(Agenda.REQUESTS_PAY),
  withProps(({ history, columns }) => ({
    name: requestsPayGridName,
    url: requestsPayUrl,
    Form: RequestsPayForm,
    dialog: false,
    gridProps: {
      columns,
      filterRow: true,
      history,
      showCheckboxes: true,
      deleting: true,
      filtering: true,
      locale: 'cz',
      adding: true,
      pageSize: 50,
      version: 2,
      ActionBar: () => <ColumnManager agenda={Agenda.REQUESTS_PAY} />
    }
  })),
  withAdditionalProps,
  withClassname({ className: 'mp-grid' })
)(Dictionary);



// WEBPACK FOOTER //
// ./src/modules/hr-requests/pays/RequestsPayGrid.tsx